import React, { useState, useEffect } from 'react';
import { Box, Button, Checkbox, Grid, Tooltip, Typography } from '@mui/material';
import axios from 'axios';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { BASEURL, ARROW, IMAGEURL, FONT_SIZE } from "../../constants/Common";
import BasicTable, { Column } from '../../components/table';
import getTheme from '../../theme/theme';
import { punchlist } from './Punchlists';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';


interface ProgressUpdate {
  id: number;
  createddate: string;
  createdby: string;
  remarks: string;
  trackingid: number;
  attachments: string | null;
  attachments2: string | null;
  attachments3: string | null;
  attachments4: string | null;
  attachments5: string | null;
  attachments6: string | null;
  signature: string;
  initials: string;
}

interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}


const PunchlistView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selecteddata, setSelecteddata] = useState<punchlist | null>(null);
  const [progressUpdates, setProgressUpdates] = useState<ProgressUpdate[]>([]);
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [projectcompleted, setProjectcompleted] = useState(false);
  const userraccess = JSON.parse("" + localStorage.getItem('userrole'));
  const moduleAccess = userraccess?.modulesaccess;
  const subscriptionstatus = localStorage.getItem('subscriptionstatus');

  useEffect(() => {
    const argpunchlistData = location?.state;
    const punchlistDetails = argpunchlistData?.punchlistDetails;
    const l_projectNamesData = argpunchlistData?.projectNamesData;

    if (punchlistDetails) {
      setSelecteddata(punchlistDetails);
    } else {
      setSelecteddata(null);
    }

    if (l_projectNamesData) {
      setProjectNamesData(l_projectNamesData);
    }
    if (selecteddata?.id) {
      fetchProgressUpdates(selecteddata.id);
    }
  }, [selecteddata, projectNamesData]);

  useEffect(() => {
    if (selecteddata && projectNamesData.length > 0) {
      const project = projectNamesData.find(
        (project) => project.project_name === selecteddata.projectname
      );
      if (project?.project_status === "Completed") {
        setProjectcompleted(true);
      } else {
        setProjectcompleted(false);
      }
    }
  }, [selecteddata, projectNamesData]);

  const fetchProgressUpdates = async (id: number) => {
    try {
      const upd_url = `${BASEURL}/punchlists/progressupdate/${id}/`;
      const response = await axios.get(upd_url, {
        headers: { Accept: 'application/json' },
      });

      setProgressUpdates(response.data.punchlist_progress_update);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditClick = () => {
    setSelecteddata((prevState) => ({
      ...prevState!,
      remarks: '',
      attachments: null, attachments2: null, attachments3: null,
      attachments4: null, attachments5: null, attachments6: null,
      signature: '',
      initials: '',
    }));


    navigate('/punchlist-details-edit', { state: { punchlistDetails: selecteddata, projectNamesData: projectNamesData, progressUpdates: progressUpdates } });

  };

  const columns: Column[] = [
    { id: 'date', label: 'Date', align: 'left' },
    { id: 'entryby', label: 'Entry By', align: 'left' },
    { id: 'remarks', label: 'Remarks', align: 'left' },
    { id: 'attachments', label: 'Attachments', align: 'left' },
    { id: 'signature', label: 'Signature', align: 'left' },
  ];


  const renderAttachment = (progress: any) => {
    let att1 = getAttachmentsUrl(progress?.attachments)
    let att2 = getAttachmentsUrl(progress?.attachments2)
    let att3 = getAttachmentsUrl(progress?.attachments3)
    let att4 = getAttachmentsUrl(progress?.attachments4)
    let att5 = getAttachmentsUrl(progress?.attachments5)
    let att6 = getAttachmentsUrl(progress?.attachments6)
    return (
      <>
        {att1} {att2 && <br />}
        {att2} {att3 && <br />}
        {att3} {att4 && <br />}
        {att4} {att5 && <br />}
        {att5} {att6 && <br />}
        {att6}
      </>
    );
  }


  const downloadImage = async (imageUrl : string) => {
    const imageUrlPath = BASEURL + '/download_image' ;

    if (imageUrl) {
      try {
        // Fetch the image blob using the imageUrl from the metadata
   //     const response = await axios.get(imageUrlPath, {
        const response = await axios.get(`${imageUrlPath}?image_name=${encodeURIComponent(imageUrl)}`, {
            responseType: 'blob',
        });

        // Create a URL for the blob object
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        const downloadUrl = window.URL.createObjectURL(blob);

        const fileName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);

        // Create an anchor element and trigger a download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName); // You can also dynamically set the filename here
        document.body.appendChild(link);
        link.click();
        link.remove();  // Clean up by removing the link
      } catch (error) {
        console.error('Failed to download the image:', error);
      }
    }
  };




  const getAttachmentsUrl = (attachmentUrl: string | null) => {
    return attachmentUrl ? (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault(); // Prevent default link behavior
          downloadImage(attachmentUrl); // Call the downloadImage function
        }}
      >
        {attachmentUrl.split('/').pop()} {/* Display file name */}
      </a>
    ) : '';
  };

  const rows = progressUpdates
    .filter(progress => progress.trackingid === selecteddata?.id)
    .map(progress => ({
      date: progress.createddate,
      entryby: progress.createdby,
      remarks: progress.remarks,
      attachments: renderAttachment(progress),
      // signature: progress.initials,
      signature: (
        <span style={{ fontSize: FONT_SIZE }}>
          {progress.initials}
        </span>
      ),
    }));
  rows.reverse();

  const renderChecklistItems = (checklist: string) => {
    try {
      const checklistArray = JSON.parse(checklist) as { text: string; checked: boolean }[]; // Parse the JSON string to get the array of objects
      return (
        <ul style={{ marginBottom: '-10px', marginLeft: '-55px' }}>
          {checklistArray.map((item, index) => (
            <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
              <Checkbox
                checked={item.checked} // Use item.checked for the checkbox state
                disabled
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 25 },
                  '&.Mui-checked': {
                    color: 'black',
                  },
                }}
              />
              <span style={{ marginLeft: '5px' }}>{item.text}</span>
            </li>
          ))}
        </ul>
      );
    } catch (error) {
      console.error('Error parsing checklist JSON:', error);
    }
  };


  return (
    <ThemeProvider theme={getTheme()}>
      <Box>
        <Box sx={{ position: 'relative', top: 0, right: 0, mt: '-70px' }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box >
              <Typography variant='h6' gutterBottom>
                <Link to={'/punchlists'} >Punchlists</Link> {ARROW} View
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                {/* Edit button */}
                <div
                  style={{
                    opacity:
                      (moduleAccess !== 'Owner' && moduleAccess !== 'Edit') ||
                        subscriptionstatus !== 'Active' ||
                        projectcompleted
                        ? 0.5
                        : 1,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (
                        (moduleAccess === 'Owner' || moduleAccess === 'Edit') &&
                        subscriptionstatus === 'Active' &&
                        !projectcompleted
                      ) {
                        handleEditClick();
                      }
                    }}
                    sx={{ mr: 1 }}
                  >
                    Edit
                  </Button>
                </div>

                {/* Conditional messages below the button */}
                <div style={{ marginTop: '4px' }}>
                  {moduleAccess !== 'Owner' && moduleAccess !== 'Edit' && (
                    <p style={{
                      color: 'gray',
                      fontStyle: 'italic',
                      fontWeight: 'bold',
                      margin: '2px 0' // Adjust vertical margins for small gap
                    }}>
                      You do not have edit access.
                    </p>
                  )}
                  {subscriptionstatus !== 'Active' && (
                    <p style={{
                      color: 'gray',
                      fontStyle: 'italic',
                      fontWeight: 'bold',
                      margin: '2px 0' // Adjust vertical margins for small gap
                    }}>
                      Your subscription is expired.
                    </p>
                  )}
                  {projectcompleted && (
                    <p style={{
                      color: 'gray',
                      fontStyle: 'italic',
                      fontWeight: 'bold',
                      margin: '2px 0' // Adjust vertical margins for small gap
                    }}>
                      This project is completed.
                    </p>
                  )}
                </div>
              </div>
            </Box>
          </Box>

        </Box>

        {selecteddata ? (
          <Grid container spacing={2} sx={{ mt: '5px' }}>
            <Grid item xs={12}>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Title</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '18px' }}>
                      {selecteddata.title}
                    </Box>
                  </Grid>
                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Project Name</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.projectname}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Status</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.status}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Created By</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.createdby}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Assigned To</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.assignedto}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '10px', ml: '30px' }}>
                    <strong>Created Date</strong>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.createddate}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Description</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.description}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Priority</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {selecteddata.priority}
                    </Box>
                  </Grid>

                  <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                    <p><strong>Checklist</strong></p>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    <Box sx={{ mt: '15px' }}>
                      {renderChecklistItems(selecteddata.checklist)}
                    </Box>
                  </Grid>
                </Grid>

                <h3 style={{ marginTop: '60px' }}>Progress Update</h3>
                <Box sx={{ marginTop: '30px', ml: '-35px', mr: '-40px' }}>
                  <BasicTable columns={columns} rows={rows} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Typography>Loading...</Typography>
        )}
        <FloatingButton />
      </Box>
    </ThemeProvider>
  );
};

export default PunchlistView;